export default __webpack_public_path__ + "static/media/AcceptedCollaboratorStatusIcon.f2a2c030.svg";